module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "70vh"
    }
  }, [_c('label-tag', {
    attrs: {
      "tagArray": [_vm.$t('list_of_students')]
    },
    on: {
      "createCode": _vm.produceCode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-5",
    staticStyle: {
      "overflow": "auto",
      "min-height": "70vh"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('selected')) + " "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-size": "1rem",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.selectedAll
    },
    model: {
      value: (_vm.checkedAll),
      callback: function($$v) {
        _vm.checkedAll = $$v
      },
      expression: "checkedAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('all_selected')))])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('your_serial_number')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('valid_time')))])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.studentNo) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.realName) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "type": "checkbox",
        "name": "",
        "id": ""
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "click": function($event) {
          return _vm.selectedStudent(item.id)
        },
        "change": function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "checked", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.code) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.effective) + "\n            ")])])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.getList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c4dcfea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/StudentList.vue
// module id = 788
// module chunks = 3